import { httpClient } from 'api';
import { Organization, OrganizationInfo } from 'types/Organization';
import { OrganizationMembership } from 'types/Membership';

export const organizationsApi = {
	getOrganizationByNameInfo: ({ organizationName }: { organizationName: string }) =>
		httpClient.get<OrganizationInfo>(`organizations/${organizationName}/info`),
	getOrganizationByName: ({ organizationName }: { organizationName: string }) =>
		httpClient.get<Organization>(`organizations/${organizationName}`),
	getMyOrganizations: ({ organizationName }: { organizationName: string }) =>
		httpClient.get<Organization[]>(`organizations/admin/${organizationName}/list`),
	getOrganizationDetails: ({ organizationName }: { organizationName: string }) =>
		httpClient.get<Organization>(`organizations/admin/${organizationName}`),
	editOrganization: (organizationName: string, data: { displayName: string; language: string }) =>
		httpClient.put<void>(`organizations/admin/${organizationName}/edit`, data),
	// editOrganization: ({
	// 	organizationName,
	// 	displayName,
	// 	language,
	// }: {
	// 	organizationName: string;
	// 	displayName: string;
	// 	language: string;
	// }) => httpClient.put<any>(`organizations/admin/${organizationName}/edit`, { displayName, language }),
	addProgramToOrganization: ({
		organizationName,
		displayName,
		authRequired,
		name,
		landingContent,
	}: {
		organizationName: string;
		displayName: string;
		authRequired: boolean;
		name: string;
		landingContent: string;
	}) =>
		httpClient.post<any>(`organizations/admin/${organizationName}/program`, {
			displayName,
			name,
			authRequired,
			landingContent,
		}),
	getOrganizationMemberships: ({ organizationName }: { organizationName: string }) =>
		httpClient.get<OrganizationMembership[]>(`organizations/admin/${organizationName}/memberships`),
	getOrganizationAdminMemberships: ({ organizationName }: { organizationName: string }) =>
		httpClient.get<OrganizationMembership[]>(`organizations/admin/${organizationName}/memberships/admins`),
	getOrganizationPrograms: ({ organizationName }: { organizationName: string }) =>
		httpClient.get<any[]>(`organizations/admin/${organizationName}/programs`),
	manageMyOrganizationMembership: ({
		organizationName,
		membershipId,
		role,
	}: {
		organizationName: string;
		membershipId: number;
		role: string;
	}) =>
		httpClient.put<any>(`organizations/admin/${organizationName}/membership/${membershipId}`, {
			role,
		}),
	removeMyOrganizationMembership: ({
		organizationName,
		membershipId,
	}: {
		organizationName: string;
		membershipId: number;
	}) => httpClient.delete<any>(`organizations/admin/${organizationName}/membership/${membershipId}`),
};
